// Styles
import MaturityBannerStyle from "../../../../assets/styles/materialUI/questionnaire/assessmentResult/assessmentDashboard/MaturityBannerStyle";

export default function MaturityBanner({ score }) {
	const dynamicColor = {
		0: "red",
		"Not Started": "red",
		notStarted: "red",
		2: "yellow",
		Developing: "yellow",
		developing: "yellow",
		3: "orange",
		Established: "orange",
		established: "orange",
		4: "lightgreen",
		Integrated: "lightgreen",
		integrated: "lightgreen",
		5: "darkgreen",
		Advanced: "darkgreen",
		advanced: "darkgreen",
	}[score];
	const classes = MaturityBannerStyle({ color: dynamicColor });

	return <span className={classes.banner} />;
}
